import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setAvatar2Id, setTimeStamp } from '../../../actions/user';

import {
  FormUpload,
  NameUser,
  ZoomPhoto,
  WrapperButtons,
  FormButtons,
  FormButtonsInvested,
  StyledAlerts
} from './styleFormAvatar';
import { updateAvatarHeaderImage } from '../../../utils/apiUser';

const FormAvatar = ({
  className,
  edit,
  dataFormAvatar,
  changeView,
  changeImg,
  setAvatar,
  getDiametre,
  setImage,
  updateTimeStamp,
  avatar,
  setAvatar2,
  setImageResult,
  user,
  timeStamp,
  isFormat
}) => {
  const [saved, SetSaved] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    SetSaved(setImageResult);
    setSaving(false);
  }, [setImageResult]);

  const saveAvatar = () => {
    setAvatar(avatar)
      .then(() => {
        SetSaved(true);
        setTimeout(() => SetSaved(false), 5000);
        setAvatar2(avatar);
      })
      .catch(() => {
        SetSaved(false);
      });
  };

  const saveImage = () => {
    const newTime = timeStamp || new Date().getTime();
    updateTimeStamp(newTime);
    setImage();
    setSaving(true);
    setAvatar2(avatar);
    updateAvatarHeaderImage(user.userId);
    setTimeout(() => window.location.reload(), 3000);
  };

  return (
    <div>
      <FormUpload className={className}>
        {dataFormAvatar && (
          <React.Fragment>
            <NameUser>{dataFormAvatar.userName}</NameUser>
            {changeImg && (
              <ZoomPhoto max={400} min={0} onChange={val => getDiametre(val)} />
            )}
            <WrapperButtons>
              {!edit && dataFormAvatar.perfil && (
                <FormButtonsInvested secondary>Editar</FormButtonsInvested>
              )}

              {changeImg && (
                <React.Fragment>
                  <FormButtonsInvested
                    secondary
                    type="button"
                    disabled={saved}
                    onClick={() => {
                      document.getElementById('inputFileImg').click();
                    }}
                  >
                    {user.avatarPhoto ? 'Cambiar foto' : 'Subir foto'}
                  </FormButtonsInvested>
                  <FormButtons
                    type="button"
                    secondary1
                    disabled={saved || !isFormat}
                    onClick={() => {
                      saveImage();
                    }}
                  >
                    Guardar
                  </FormButtons>
                </React.Fragment>
              )}

              {!changeImg && (
                <React.Fragment>
                  <FormButtonsInvested
                    type="button"
                    disabled={saved}
                    onClick={() => changeView('changeImage')}
                    ghost
                    dark
                  >
                    Cambiar foto
                  </FormButtonsInvested>
                  <FormButtons
                    type="button"
                    disabled={saved || !isFormat}
                    secondary
                    onClick={() => {
                      saveAvatar();
                    }}
                  >
                    Guardar
                  </FormButtons>
                </React.Fragment>
              )}

              {saved !== null && (
                <>
                  {saved ? (
                    <StyledAlerts visible={saved} type="success">
                      Nueva imagen guardada, refrescando...
                    </StyledAlerts>
                  ) : (
                    <StyledAlerts visible={saved} type="error">
                      Error al guardar la imagen
                    </StyledAlerts>
                  )}
                </>
              )}
              <StyledAlerts visible={saving} type="success">
                Guardando foto...
              </StyledAlerts>
              <StyledAlerts visible={!isFormat} type="error">
                Debes subir una imagen con formato JPG, PNG, BMP o TIFF
              </StyledAlerts>
            </WrapperButtons>
          </React.Fragment>
        )}
      </FormUpload>
    </div>
  );
};

FormAvatar.propTypes = {
  setAvatar: PropTypes.func,
  avatar: PropTypes.string,
  setImage: PropTypes.func,
  changeView: PropTypes.func,
  getDiametre: PropTypes.func,
  changeImg: PropTypes.bool,
  className: PropTypes.string,
  edit: PropTypes.bool,
  setImageResult: PropTypes.bool,
  dataFormAvatar: PropTypes.shape({
    userName: PropTypes.string,
    type: PropTypes.string,
    perfil: PropTypes.string
  }),
  avatarPhoto: PropTypes.bool
};

const mapStateToProps = state => ({
  timeStamp: state.user.timeStamp
});

const mapDispatchToProps = dispatch => ({
  setAvatar2: idAvatar => dispatch(setAvatar2Id(idAvatar)),
  updateTimeStamp: time => dispatch(setTimeStamp(time))
});

export default connect(mapStateToProps, mapDispatchToProps)(FormAvatar);
